export default __webpack_public_path__ + "static/media/disable.775f309f.svg";